import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import AdminSidebar from "../shared/AdminSidebar";
import "./AjouterComp.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { getNodeApiBase } from "../../../utils/apiBase";

const AjouterUneComp = () => {
  const [selectedBudget, setSelectedBudget] = useState("");
  const [budgets, setBudgets] = useState([]);
  const [evaluations, setEvaluations] = useState([]);
  const [selectedEvaluation, setSelectedEvaluation] = useState("");
  const navigate = useNavigate();
  const nodeApiBase = getNodeApiBase();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/getBudgets.php`)
      .then((response) => {
        setBudgets(response.data || []);
      })
      .catch((error) => {
        console.error("Error fetching budgets:", error);
      });

    // Fetch evaluation grids from Node.js API
    fetch(`${nodeApiBase}/api/evaluation/list`)
      .then((r) => r.json())
      .then((json) => setEvaluations(Array.isArray(json?.data) ? json.data : []))
      .catch((e) => console.error("Error fetching evaluations:", e));
  }, [nodeApiBase]);

  const handleChange = (e) => {
    console.log("Selected Budget ID:", e.target.value); // Should print only the ID
    setSelectedBudget(e.target.value); // Update state with only the ID
  };

  const handleEvaluationChange = (e) => {
    setSelectedEvaluation(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Confirm that selectedBudget has only the ID
    console.log("Selected Budget ID for submission:", selectedBudget);

    const formData = new FormData(event.target);

    // Ensure only the ID is included in FormData
    formData.set("ID_budget_parametre", selectedBudget);
    formData.set("ID_Evaluation", selectedEvaluation);

    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`); // Ensure only the ID is sent
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/addCompetitions.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        console.log("Success:", response.data);
        alert("La compétition a été ajoutée avec succès.");
        event.target.reset();
        setSelectedBudget("");
        setSelectedEvaluation("");
        navigate("/admin-projet"); // Redirect to /admin-projet after success
      } else {
        throw new Error("Network response was not ok");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Une erreur est survenue lors de l'ajout de la compétition.");
    }
  };

  return (
    <>
      <div className="d-flex">
        <AdminSidebar />
        <div className="main-container admin-content">
          <div className="form-card">
            <h2 className="form-title">Ajouter une compétition</h2>
            <form
              className="form-content"
              id="create-competition-form"
              onSubmit={handleSubmit}
            >
              <div className="form-group">
                <label htmlFor="titre">Nom de la compétition</label>
                <input
                  type="text"
                  id="titre"
                  name="titre"
                  placeholder="Nom de la compétition"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="libelle">Libellé</label>
                <input
                  type="text"
                  id="libelle"
                  name="libelle"
                  placeholder="Libellé"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="date_debut">Date de début</label>
                <input type="date" id="date_debut" name="date_debut" required />
              </div>

              <div className="form-group">
                <label htmlFor="date_fin">Date de fin</label>
                <input type="date" id="date_fin" name="date_fin" required />
              </div>

              <div className="form-group full-width">
                <label htmlFor="annee_competition">
                  Année de la compétition
                </label>
                <input
                  type="text"
                  id="annee_competition"
                  name="annee_competition"
                  placeholder="Année (ex: 2023)"
                  required
                />
              </div>

              <div className="form-group full-width">
                <label>En ligne :</label>
                <div className="radio-group">
                  <label>
                    <input type="radio" name="enligne" value="2" /> Non
                  </label>
                  <label>
                    <input type="radio" name="enligne" value="1" /> Oui
                  </label>
                </div>
              </div>

              <div className="form-group full-width">
                <label htmlFor="evaluation">Grille d'évaluation</label>
                <select
                  id="evaluation"
                  name="ID_Evaluation"
                  value={selectedEvaluation}
                  onChange={handleEvaluationChange}
                  required
                >
                  <option value="">Sélectionner une grille</option>
                  {evaluations.map((ev) => (
                    <option key={ev.ID_Evaluation} value={ev.ID_Evaluation}>
                      {ev.Titre_evaluation}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group full-width">
                <label htmlFor="budget">Budget</label>
                <select
                  id="budget"
                  name="ID_budget_parametre"
                  value={selectedBudget}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionner un budget</option>
                  {budgets.map((budget) => (
                    <option key={budget.id} value={budget.id}>
                      {budget.appellation}
                    </option>
                  ))}
                </select>
              </div>

              <button type="submit" className="submit-button">
                ENREGISTRER
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AjouterUneComp;
